import type {EmailSequenceTemplate} from './email-template-designer-modal';

export const PLACEHOLDER_ID = 'new-emailSequenceTemplate';

export function copySharedSequenceTemplate(
    sharedTemplate: EmailSequenceTemplate
): EmailSequenceTemplate {
    return {
        ...sharedTemplate,
        id: PLACEHOLDER_ID,
        isShared: true,
        isImmutable: false,
        // This could be set to the current user, but that is somewhat complicated and probably unneeded.
        creatorUser: {
            __typename: 'User',
            id: '',
            name: '',
            isEnabled: true,
        },
        userChildSequenceTemplate: {
            ...sharedTemplate,
            id: PLACEHOLDER_ID,
            isShared: true,
            isImmutable: false,
            creatorUser: {
                __typename: 'User',
                id: '',
                name: '',
                isEnabled: true,
            },
        },
    };
}
